/**
 * Pointer event constants.
 */
export default class PointerEvents {

    static ROLLOUT = "pointerout";
    static CANCEL = "pointercancel";
    static DOWN = "pointerdown";
    static UP = "pointerup";
    static UPOUTSIDE = "pointerupoutside";
    static MOVE = "pointermove";
    static OVER = 'pointerover';
    static BUT_ROLLOVER = "BUT_ROLLOVER";
    static BUT_ROLLOUT = "BUT_ROLLOUT";
    static UPDATE = "UPDATE";
}
